import { render, staticRenderFns } from "./common-loading.vue?vue&type=template&id=5a5c52c8&scoped=true&"
import script from "./common-loading.vue?vue&type=script&lang=js&"
export * from "./common-loading.vue?vue&type=script&lang=js&"
import style0 from "./common-loading.vue?vue&type=style&index=0&id=5a5c52c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c52c8",
  null
  
)

export default component.exports